module.exports = __webpack_public_path__ + "static/media/business-documents-min.08f657fd.jpg";